import React from "react";
import "./AboutUsHero.css";
import HeroImage from "../../assets/Rectangle2.jpg.webp";
import LightningIcon from "../../assets/Vector1.png.webp";

const AboutUsHero: React.FC = () => {
  return (
    <section
      className="about-us-hero"
      style={{ backgroundImage: `url(${HeroImage})` }}
    >
      <div className="about-hero-overlay"></div>

      {/* New wrapper to match navbar container width & padding */}
      <div className="about-hero-container">
        <div className="about-hero-content">
          <h1>
            Embrace the outdoors
            <br />
            in all its glory
          </h1>
        </div>

        <div className="about-hero-tagline">
          <div className="about-tagline-icon">
            <img src={LightningIcon} alt="Lightning Icon" />
          </div>
          <p>Brighten your world with style and efficiency.</p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHero;
